import { useState } from "react";
import { Link } from "react-router-dom";
import { HeartPulse, Inbox, MessageCircle, Shield, X } from "lucide-react";

const STEPS = [
  { icon: HeartPulse, title: "Daily check-ins", text: "Log your mood, energy and sleep in under a minute. Patterns show up in Insights over time.", to: "/checkin", cta: "Try a check-in" },
  { icon: Inbox, title: "Inbox & supporters", text: "Invite people you trust. Their notes and your conversations live in your Inbox.", to: "/supporters", cta: "Add a supporter" },
  { icon: MessageCircle, title: "AI chat companion", text: "Talk things through any time with Mia, your gentle AI companion.", to: "/ai", cta: "Say hello" },
  { icon: Shield, title: "Your safety plan", text: "Build a plan for hard moments and save a wallet card to your lock screen.", to: "/safety", cta: "Open safety plan" },
];

export const tourKey = (uid) => `mm_tour_done_${uid}`;

export const WelcomeTour = ({ userId }) => {
  const [step, setStep] = useState(() => (localStorage.getItem(tourKey(userId)) ? -1 : 0));
  if (step < 0) return null;
  const done = () => { localStorage.setItem(tourKey(userId), "1"); setStep(-1); };
  const s = STEPS[step];
  const last = step === STEPS.length - 1;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="welcome-tour">
      <div className="mm-card p-7 max-w-md w-full mm-fade-up relative" key={step} role="dialog" aria-label="Welcome tour">
        <button onClick={done} className="absolute top-4 right-4 text-mm-muted hover:text-mm-text" aria-label="Close tour" data-testid="welcome-tour-close"><X size={18} /></button>
        <div className="text-xs font-semibold text-mm-primary uppercase tracking-wider" data-testid="welcome-tour-step">Welcome · {step + 1} of {STEPS.length}</div>
        <div className="w-14 h-14 rounded-2xl mm-gradient text-white flex items-center justify-center mt-4"><s.icon size={26} /></div>
        <h2 className="text-2xl font-bold mt-4" data-testid="welcome-tour-title">{s.title}</h2>
        <p className="text-mm-muted mt-2">{s.text}</p>
        <Link to={s.to} onClick={done} className="text-sm text-mm-primary font-semibold mt-3 inline-block" data-testid="welcome-tour-cta">{s.cta} →</Link>
        <div className="flex items-center justify-between mt-6">
          <div className="flex gap-1.5">{STEPS.map((x, i) => <span key={x.title} className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 mm-gradient" : "w-1.5 bg-mm-line"}`} />)}</div>
          <div className="flex gap-2">
            {!last && <button onClick={done} className="mm-btn-ghost !py-2 !px-4" data-testid="welcome-tour-skip">Skip</button>}
            <button onClick={() => (last ? done() : setStep(step + 1))} className="mm-btn !py-2 !px-5" data-testid="welcome-tour-next">{last ? "Get started" : "Next"}</button>
          </div>
        </div>
      </div>
    </div>
  );
};
